export const DASHBOARD_WIDGET = {
  AGENCY_EVOLUTION: "agency-evolution",
  AGENT_VERSIONS_TOP5: "pie-agent-versions",
  AGENTS_PER_DAY: "agents-per-day",
  ALERT_EVOLUTION: "alert-evolution",
  ALERTS_PER_DAY: "alerts-per-day",
  ALERTS_PER_VACCINE: "alerts-per-vaccine",
  BAR_PREFIX: "bar-",
  COMPUTER_EVOLUTION: "computer-evolution",
  INSTANCES: "instances",
  LAST_ALERTS: "last-alerts",
  LATEST_NEWS: "latest-news",
  PIE_PREFIX: "pie-",
  TOTAL_PREFIX: "total-",
  VACCINE_EVOLUTION: "vaccine-evolution",
};

export const DASHBOARD_DOUGHNUT_TITLE = {
  AGENT_VERSIONS_TOP5: "dashboard.charts.versionall.title",
};

export const WIDGET_TYPE = {
  BAR: "bar",
  CUSTOM: "custom",
  NUMBER: "number",
  PIE: "pie",
};

export const WIDGET_COLUMNS = {
  QUARTER: 3,
  THIRD: 4,
  HALF: 6,
  TWO_THIRDS: 8,
  FULL: 12,
};

export const EVOLUTION_RANGE = { LAST_7: 7, LAST_30: 30, LAST_365: 365 };

export const NUMBER_WIDGET_ICONS = {
  "dashboard.charts.totalAlerts.subtitle": "mc-alert",
  "dashboard.charts.totalAgencies.subtitle": "mc-building",
  "dashboard.charts.totalComputers.subtitle": "mc-computer",
  "dashboard.charts.totalVaccines.subtitle": "mc-syringe",
};

export const LINE_CHART_WIDGETS = [
  {
    id: DASHBOARD_WIDGET.COMPUTER_EVOLUTION,
    titleKey: "dashboard.charts.computerEvolution",
    statsKey: "computerEvolutionStats",
    action: "updateComputerEvolutionStats",
    testId: "computerEvolution",
  },
  {
    id: DASHBOARD_WIDGET.ALERT_EVOLUTION,
    titleKey: "dashboard.charts.alertEvolution",
    statsKey: "alertEvolutionStats",
    action: "updateAlertEvolutionStats",
    testId: "alertEvolution",
  },
  {
    id: DASHBOARD_WIDGET.VACCINE_EVOLUTION,
    titleKey: "dashboard.charts.avaliableVaccinesEvolution",
    statsKey: "vaccineEvolutionStats",
    action: "updateVaccineEvolutionStats",
    testId: "avaliableVaccinesEvolution",
  },
  {
    id: DASHBOARD_WIDGET.AGENTS_PER_DAY,
    titleKey: "dashboard.charts.connectedAgentsPerDay",
    statsKey: "agentsPerDayEvolutionStats",
    action: "updateAgentsPerDayEvolutionStats",
    testId: "connectedAgentsPerDay",
    comparison: true,
  },
  {
    id: DASHBOARD_WIDGET.ALERTS_PER_DAY,
    titleKey: "dashboard.charts.alertsPerDay",
    statsKey: "alertsPerDayEvolutionStats",
    action: "updateAlertsPerDayEvolutionStats",
    testId: "alertsPerDay",
    comparison: true,
  },
  {
    id: DASHBOARD_WIDGET.AGENCY_EVOLUTION,
    titleKey: "dashboard.charts.agencyEvolution",
    statsKey: "agencyEvolutionStats",
    action: "updateAgencyEvolutionStats",
    testId: "agencyEvolution",
  },
];
